(function(){
  var still = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var blocks = document.querySelectorAll('.rise, .stage');
  var nums = document.querySelectorAll('[data-to]');

  var hero = document.querySelector('.hero video');
  if (hero && still) { hero.removeAttribute('autoplay'); hero.pause(); }

  var root0 = document.documentElement;

  /* Hero-Video: geladen wird die Fassung, die das Geraet wirklich braucht.
     Massgeblich ist die Fensterbreite mal Pixeldichte - gedeckelt bei 2, weil
     ein Hintergrundvideo hinter Verlauf und Schrift von mehr nicht profitiert.
     Bei Datensparmodus oder 2G bleibt es beim Standbild. */
  var heroVid = document.querySelector('.hero video');
  if (heroVid) {
    var netz = navigator.connection || navigator.webkitConnection || {};
    var art = netz.effectiveType || '';
    /* Hochkant gibt es eine eigene Fassung. Im queren Video muss das Bild
       die Hoehe fuellen und wird dabei seitlich auf rund ein Viertel
       beschnitten - die Haelfte der eingebrannten Woerter stand damit
       ausserhalb des Bildes. Die Hochkant-Fassung ist dafuer geschnitten.
       Die Schwelle ist dieselbe wie die der Medienabfrage fuer das
       Standbild, damit nicht das eine Bild zum anderen Video gehoert. */
    function passendeFassung(){
      /* still = das Geraet bittet um wenig Bewegung. Bisher wurde hier nur
         das autoplay-Attribut entfernt, das Skript hat den Film danach
         trotzdem geladen und per play() gestartet. Jetzt bleibt es in dem
         Fall beim Standbild - so, wie es gemeint war. */
      if (still || netz.saveData || art.indexOf('2g') !== -1) return null;
      var braucht = window.innerWidth * Math.min(window.devicePixelRatio || 1, 2);
      if (window.innerHeight >= window.innerWidth) {
        return (art === '3g' || braucht <= 640) ? heroVid.dataset.hochKlein
             : braucht <= 1200 ? heroVid.dataset.hochGross
             : heroVid.dataset.hochRiesig;
      }
      return (art === '3g' || braucht <= 1280) ? heroVid.dataset.klein
           : braucht <= 1600 ? heroVid.dataset.mittel
           : heroVid.dataset.gross;
    }

    function ladeFassung(){
      var fassung = passendeFassung();
      if (!fassung || fassung === heroVid.getAttribute('src')) return;
      /* Beim Drehen soll die Stelle im Film erhalten bleiben - sonst
         springt das Video mitten im Satz zurueck an den Anfang. */
      var stelle = heroVid.currentTime || 0;
      /* Erst abspielen, wenn genug Daten da sind. Ein sofortiges play()
         startet beim ersten decodierbaren Bild und ruckelt dann, bis der
         Puffer nachgezogen ist. Das Standbild steht so lange - es ist das
         erste Bild des Videos, der Wechsel ist also nicht zu sehen. */
      heroVid.addEventListener('canplay', function(){
        if (stelle && heroVid.duration) heroVid.currentTime = stelle % heroVid.duration;
        var lauf = heroVid.play();
        if (lauf && lauf.catch) lauf.catch(function(){});
      }, {once:true});
      /* Nicht bei canplay, sondern wenn wirklich Bilder kommen - sonst
         faellt das Standbild weg, bevor der Film es ersetzt. */
      heroVid.addEventListener('playing', function(){
        if (heroVid.parentNode) heroVid.parentNode.classList.add('laeuft');
      }, {once:true});
      heroVid.src = fassung;
    }

    ladeFassung();
    /* Wird das Geraet gedreht, passt die geladene Fassung nicht mehr zum
       Fenster: das Hochformat wuerde quer oben und unten auf ein Viertel
       beschnitten. Also neu waehlen - meist liegt die Datei dann schon im
       Zwischenspeicher. */
    var drehUhr;
    window.addEventListener('resize', function(){
      clearTimeout(drehUhr);
      drehUhr = setTimeout(ladeFassung, 250);
    });
  }

  var navEl = document.querySelector('.nav'), heroEl = document.querySelector('.hero');
  /* 58 = Hoehe der zusammengeschobenen Leiste; so ist --np genau dann 1,
     wenn die Hero-Unterkante die Leiste erreicht. Die Strecke wird gecacht,
     damit pro Frame kein Layout erzwungen wird. */
  var navSpan = 1;
  function navMeasure(){
    navSpan = Math.max(1, (heroEl ? heroEl.offsetHeight : window.innerHeight) - 58);
  }
  /* An --np haengen Hoehe und Logogroesse, jede Aenderung kostet also Layout.
     Deshalb in 32 Stufen rastern und nur bei echtem Wechsel schreiben. */
  var npLast = -1, NP_STEPS = 32;
  function navProgress(){
    if (!navEl) return;
    var p = window.scrollY / navSpan;
    if (p < 0) p = 0; else if (p > 1) p = 1;
    var q = Math.round(p * NP_STEPS) / NP_STEPS;
    if (q === npLast) return;
    npLast = q;
    navEl.style.setProperty('--np', q);
    root0.classList.toggle('nav-solid', q >= 1);
    /* Der Aufruf rechts blendet mit --np ein. Anklickbar ist er, sobald man
       ihn sieht - ab einem Achtel Deckkraft, nicht erst bei voller. */
    root0.classList.toggle('nav-da', q >= 0.125);
  }
  navMeasure();
  window.addEventListener('resize', function(){ navMeasure(); npLast = -1; navProgress(); });
  navProgress();


  /* ruhig: das Geraet bittet um wenig Bewegung ("Bewegung reduzieren" auf dem
     iPhone), oder dem Browser fehlt der IntersectionObserver. Dann steht
     alles sofort auf dem Endzustand.
     Frueher stand an dieser Stelle ein return. Damit endete das ganze Skript,
     und alles weiter unten fiel mit aus: die Bestaetigung nach dem Eintragen,
     die Texte hinter den Teilen-Knoepfen, das Umdrehen der Karten, die Pfeile
     der Schienen, die Farbe der Kopfzeile. Die Adresse kam trotzdem bei Brevo
     an, weil das Formular auch ohne Skript abschickt - nur sah der Besucher
     davon nichts. Jetzt wird nur noch die Bewegung selbst ausgelassen. */
  var ruhig = still || !('IntersectionObserver' in window);
  if (ruhig) {
    blocks.forEach(function(b){ b.classList.add('seen'); });
    nums.forEach(function(n){ n.textContent = n.getAttribute('data-label'); });
  } else {
    var io = new IntersectionObserver(function(es){
      es.forEach(function(e){
        if (!e.isIntersecting) return;
        e.target.classList.add('seen');
        io.unobserve(e.target);
      });
    }, {rootMargin:'0px 0px -10% 0px', threshold:.05});
    blocks.forEach(function(b){ io.observe(b); });
  }



  function countUp(el){
    var to = parseFloat(el.getAttribute('data-to'));
    var label = el.getAttribute('data-label');
    var dur = 1200, t0 = null;
    function frame(t){
      if (t0 === null) t0 = t;
      var p = Math.min((t - t0) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = Math.round(to * eased).toLocaleString('de-DE');
      if (p < 1) requestAnimationFrame(frame); else el.textContent = label;
    }
    requestAnimationFrame(frame);
  }
  if (!ruhig) {
    var ioN = new IntersectionObserver(function(es){
      es.forEach(function(e){ if (e.isIntersecting){ countUp(e.target); ioN.unobserve(e.target); } });
    }, {threshold:.6});
    nums.forEach(function(n){ n.textContent = '0'; ioN.observe(n); });
  }

  var railEl = document.getElementById('kartenrail');

  /* Bonuskarte: beim ersten Umdrehen laeuft eine Uhr. Nach drei Sekunden
     bekommt die Karte .gezeigt - damit greift die Umdreh-Regel nicht mehr,
     sie faellt in ihre Ausgangslage zurueck, und auf der Rueckseite steht
     ab dann der Aufruf statt der Wortmarke. */
  var bonusKarte = railEl && railEl.querySelector('li.bonus');
  if (bonusKarte){
    var bonusUhr = null;
    var bonusZeigen = function(){
      if (bonusUhr || bonusKarte.classList.contains('gezeigt')) return;
      bonusUhr = setTimeout(function(){
        bonusKarte.classList.add('gezeigt');
        // Jetzt ist der Aufruf sichtbar - ab hier darf er auch angesprungen
        // und mit der Tastatur bedient werden.
        var ruf = bonusKarte.querySelector('.card-cta .btn');
        if (ruf){ ruf.removeAttribute('tabindex'); ruf.removeAttribute('aria-hidden'); }
        // Zustand an die Optik angleichen: die Karte liegt wieder vorn, also
        // darf .turned nicht stehen bleiben - sonst braucht der naechste
        // Klick zwei Anlaeufe.
        bonusKarte.classList.remove('turned');
        // .zurueck haelt die Karte unten, solange der Zeiger auf ihr steht.
        // Auf dem Telefon gibt es kein Verlassen, dort wuerde die Klasse
        // haengenbleiben und jedes weitere Antippen blockieren.
        if (window.matchMedia('(hover:hover) and (pointer:fine)').matches){
          bonusKarte.classList.add('zurueck');
        }
      }, 3000);
    };
    ['mouseenter', 'focus', 'touchstart', 'click'].forEach(function(ev){
      bonusKarte.addEventListener(ev, bonusZeigen, {passive:true});
    });
    ['mouseleave', 'blur'].forEach(function(ev){
      bonusKarte.addEventListener(ev, function(){
        bonusKarte.classList.remove('zurueck');
      }, {passive:true});
    });
  }

  function turnOnly(li){
    var was = li.classList.contains('turned');
    var all = railEl.querySelectorAll('li.turned');
    for (var i = 0; i < all.length; i++) all[i].classList.remove('turned');
    if (!was) li.classList.add('turned');
  }
  if (railEl){
    var fine = window.matchMedia('(hover:hover) and (pointer:fine)');
    railEl.querySelectorAll('li').forEach(function(li){
      li.addEventListener('click', function(e){
        if (e.target.closest('a')) return;   /* Bonus-Button nicht als Umdrehen werten */
        turnOnly(li);
      });
      li.addEventListener('keydown', function(e){
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); turnOnly(li); }
      });
      /* am Zeigegeraet zaehlt der Hover: eine angeklickte Karte springt zurueck */
      li.addEventListener('mouseenter', function(){
        if (!fine.matches) return;
        var t = railEl.querySelectorAll('li.turned');
        for (var i = 0; i < t.length; i++) t[i].classList.remove('turned');
      });
    });
  }

  /* Pfeiltasten fuer jede Schiene: springt exakt ein Element weiter und
     schaltet sich an den Enden ab. Wird von Fragekarten und App-Screens
     gleichermassen benutzt. */
  function wireRail(rail, nav, startIdx){
    if (!rail || !nav) return;
    var prev = nav.querySelector('.rn.prev'), next = nav.querySelector('.rn.next');
    if (!prev || !next) return;
    function items(){ return [].slice.call(rail.children); }
    function pad(){ return parseFloat(getComputedStyle(rail).paddingLeft) || 0; }
    /* Rastet die Schiene mittig, muss auch das Sprungziel mittig gerechnet
       werden - sonst laeuft der Pfeil gegen den Schnappunkt an. */
    function mid(cs){
      return cs.length && getComputedStyle(cs[0]).scrollSnapAlign === 'center';
    }
    function targetOf(el, cs){
      return mid(cs) ? el.offsetLeft - (rail.clientWidth - el.offsetWidth) / 2
                     : el.offsetLeft - pad();
    }
    function go(dir){
      var cs = items(), x = rail.scrollLeft, idx = 0, best = Infinity;
      for (var i = 0; i < cs.length; i++){
        var d = Math.abs(targetOf(cs[i], cs) - x);
        if (d < best){ best = d; idx = i; }
      }
      idx = Math.max(0, Math.min(cs.length - 1, idx + dir));
      var ziel = targetOf(cs[idx], cs);
      /* scrollTo an einem Element kennt das iPhone erst ab iOS 14; davor
         wird die Lage direkt gesetzt. Gleiten nur, wenn Bewegung erwuenscht ist. */
      if (rail.scrollTo) rail.scrollTo({left: ziel, behavior: still ? 'auto' : 'smooth'});
      else rail.scrollLeft = ziel;
    }
    function start(){
      var cs = items();
      if (startIdx == null || !cs[startIdx]) return;
      if (rail.scrollWidth <= rail.clientWidth + 2) return;
      rail.scrollLeft = targetOf(cs[startIdx], cs);
    }
    /* Markiert das Element, das gerade in der Mitte steht, und legt fuer
       jedes fest, wie nah es der Mitte ist: 1 genau mittig, 0 eine
       Elementbreite daneben. Gemessen wird an den tatsaechlichen Kaesten auf
       dem Schirm, nicht ueber scrollLeft und offsetLeft - diese Rechnung
       haengt an Polsterung und Schnappmass und lag schon einmal daneben,
       sodass die Beschriftung des mittleren Screens stehen blieb. */
    function marker(){
      var cs = items(), i;
      if (!mid(cs)){
        for (i = 0; i < cs.length; i++){
          cs[i].classList.remove('mid');
          cs[i].style.removeProperty('--nah');
        }
        return;
      }
      var r = rail.getBoundingClientRect(), mitte = r.left + r.width / 2;
      var idx = 0, best = Infinity, abstand = [];
      for (i = 0; i < cs.length; i++){
        var k = cs[i].getBoundingClientRect();
        var d = Math.abs(k.left + k.width / 2 - mitte) / (k.width || 1);
        abstand.push(d);
        if (d < best){ best = d; idx = i; }
      }
      for (i = 0; i < cs.length; i++){
        cs[i].classList.toggle('mid', i === idx);
        /* 1.35 statt 1.8: bei 1.8 erreichte die weichende Karte ihre
           Kleinstgroesse, bevor die naechste zu wachsen begann - dazwischen
           lag ein kurzer Moment, in dem sich nichts bewegte. Mit 1.35
           ueberlappen die beiden Rampen und es laeuft durch. */
        var nah = 1 - abstand[i] * 1.35;
        cs[i].style.setProperty('--nah', nah < 0 ? 0 : nah > 1 ? 1 : nah.toFixed(3));
      }
    }
    function sync(){
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= max - 2;
      marker();
    }
    var pending = false;
    function onScroll(){
      if (pending) return;
      pending = true;
      requestAnimationFrame(function(){ pending = false; sync(); });
    }
    prev.addEventListener('click', function(){ go(-1); });
    next.addEventListener('click', function(){ go(1); });
    rail.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', sync);
    start(); sync();
    /* Beim Wechsel zwischen Raster und Schiene neu ausrichten. */
    if (startIdx != null && window.matchMedia){
      var mq = window.matchMedia('(max-width:860px)');
      var onMq = function(){ start(); sync(); };
      if (mq.addEventListener) mq.addEventListener('change', onMq);
      else if (mq.addListener) mq.addListener(onMq);
    }
  }
  /* Der Abschnitt heisst #fragen - unter #karten gibt es nichts, die
     Pfeile der Kartenschiene waren dadurch ohne Funktion. */
  wireRail(railEl, document.querySelector('#fragen .rail-nav'));
  wireRail(document.getElementById('apprail'), document.querySelector('.apps-nav'), 1);
  wireRail(document.getElementById('galrail'), document.querySelector('.gal-nav'));
  wireRail(document.getElementById('bandrail'), document.querySelector('.band-nav'));

  /* ---------- Teilen ---------- */
  (function(){
    var url  = 'https://www.bodenlos-spiel.de/';
    var titel = 'BODENLOS | 100 unversch\u00e4mt tiefgr\u00fcndige Fragen f\u00fcr Churchies';
    /* Ein Text, drei Ziele. WhatsApp kennt *fett* und _kursiv_ und macht aus
       der Adresse im Text von selbst eine Vorschaukarte. Mail und das
       Teilen-Menue des Geraets koennen die Sternchen nicht - dort stuenden sie
       als Zeichen da. Deshalb baut jede Fassung denselben Rumpf, nur die
       Auszeichnung kommt ueber eine kleine Hilfsfunktion dazu. */
    function rumpf(f, k){
      return 'Der Rebell unter den christlichen Gespr\u00e4chskartenspielen. '
           + 'Lockt dich mit Humor und Aufm\u00fcpfigkeit aus der Deckung. '
           + 'Von und f\u00fcr Menschen, die Gott lieben, gerne lachen und '
           + 'tiefe Gespr\u00e4che m\u00f6gen.\n\n'
           + '\ud83d\udcf1 Mit Smartphone-App: alle Fragen immer dabei, '
           + 'verbunden mit der Online-Community\n'
           + '\ud83c\udf81 Das perfekte Weihnachtsgeschenk: Lieferung Mitte Dezember\n'
           + '\u2764\ufe0f Fairer Preis: 20 \u20ac pro Spiel \u2013 davon gehen '
           + '2 \u20ac an Stra\u00dfenkinder auf den Philippinen\n\n'
           + 'Vom ' + f + '12. bis 31. Oktober' + f + ' hei\u00dft es: '
           + k + '1000 oder nix.' + k + ' Nur wenn 1000 Exemplare vorbestellt '
           + 'werden, wird das Spiel gedruckt \u2013 sonst gibt es den vollen '
           + 'Betrag zur\u00fcck.';
    }
    var schluss = '\n\nGerne weiterleiten an alle, die gern lachen und tiefe '
                + 'Gespr\u00e4che m\u00f6gen \ud83d\ude4f';

    var waText = '*' + titel + '*\n\n' + rumpf('*', '_')
               + '\n\n\ud83d\udc49 Jetzt vormerken: ' + url + schluss;
    /* wa.me reicht die Adresse auf dem Rechner an die installierte
       WhatsApp-Anwendung weiter, und die liest den Text unter Windows als
       Windows-1252. Umlaute, ss und das Eurozeichen stehen dort drin und
       kommen heil an - Emoji nicht, die werden zu Fragezeichenrauten. Am
       Telefon tritt das nicht auf. Deshalb bekommt der Rechner die
       Weboberflaeche, die den Text als UTF-8 nimmt. */
    var amTelefon = /Android|iPhone|iPad|iPod|Mobile/i.test(navigator.userAgent);
    var wa = document.getElementById('t-whatsapp');
    if (wa) wa.href = (amTelefon ? 'https://wa.me/?text='
                                 : 'https://web.whatsapp.com/send?text=')
                      + encodeURIComponent(waText);

    var mailText = rumpf('', '') + '\n\n\ud83d\udc49 Jetzt vormerken: ' + url + schluss;
    var mail = document.getElementById('t-mail');
    if (mail) mail.href = 'mailto:?subject=' + encodeURIComponent(titel)
            + '&body=' + encodeURIComponent(mailText);

    /* Das Geraete-Menue haengt die Adresse selbst an, deshalb steht sie hier
       nicht im Text - sonst erschiene sie zweimal. */
    var text = titel + '\n\n' + rumpf('', '') + schluss;

    // Das Teilen-Menue des Geraets gibt es nicht ueberall; der Knopf erscheint
    // nur dort, wo er auch etwas tut.
    var nativ = document.getElementById('t-native');
    if (nativ && navigator.share){
      nativ.hidden = false;
      nativ.addEventListener('click', function(){
        navigator.share({title: titel, text: text, url: url}).catch(function(){});
      });
    }

  })();


  document.querySelectorAll('.sub, .float').forEach(function(box){
    var f = box.querySelector('form');
    if (!f) return;
    f.addEventListener('submit', function(){
      /* Nicht abfangen: das Formular geht regulaer an Brevo, nur eben in das
         unsichtbare Fenster. Wuerde hier preventDefault stehen, kaeme beim
         Anbieter nichts an. Das Ereignis loest ohnehin erst aus, wenn der
         Browser die Adresse als gueltig ansieht. */
      box.classList.add('sent');
      /* Das Feld bleibt stehen und wird geleert - aber erst, nachdem der
         Browser seinen Inhalt verschickt hat. Sofort geleert ginge die
         Adresse verloren. */
      setTimeout(function(){ f.reset(); }, 800);
      /* Die Bestaetigung erscheint unter dem Formular. Auf kleinen Telefonen
         liegt diese Stelle unter dem Bildrand - dann sah es so aus, als sei
         nichts passiert. Deshalb rueckt die Seite gerade so weit nach, dass
         die Meldung ganz zu sehen ist. Kurz gewartet wird, weil das Telefon
         beim Antippen erst die Tastatur einfaehrt und sich die Hoehe des
         Fensters dabei aendert. Gleiten oder Springen regelt scroll-behavior
         im Stylesheet, also auch die Bitte um wenig Bewegung. */
      var meldung = box.querySelector('.done');
      if (meldung) setTimeout(function(){
        var r = meldung.getBoundingClientRect(), h = window.innerHeight;
        if (r.bottom > h - 24) window.scrollTo(0, window.scrollY + r.bottom - h + 24);
        else if (r.top < 72) window.scrollTo(0, window.scrollY + r.top - 96);
      }, 350);
    });
  });

  var bar = document.getElementById('bar'), tick = false, root = document.documentElement;
  /* Die Kopfzeile dunkelt genau ueber die Strecke ab, die der Hero nach oben
     wegscrollt - kein Umspringen an einer festen Schwelle. */
  var lightSecs = [].slice.call(document.querySelectorAll('.sec.light, .sec.flame'));
  var darkOver = [].slice.call(document.querySelectorAll('.fig, .hero, .prod'));
  function covers(el){
    var rr = el.getBoundingClientRect();
    return rr.top <= 2 && rr.bottom > 2;
  }
  function barTone(){
    var lit = false, i;
    for (i = 0; i < lightSecs.length; i++) if (covers(lightSecs[i])){ lit = true; break; }
    if (lit) for (i = 0; i < darkOver.length; i++) if (covers(darkOver[i])){ lit = false; break; }
    root.classList.toggle('light-bar', lit);
  }
  /* ---------- Zielgruppe: einzeilig, notfalls ueber beide Spalten --------- */
  var tagListe = document.querySelector('.tags');
  function tagsMessen(){
    if (!tagListe) return;
    var lis = tagListe.querySelectorAll('li'), i, li;
    tagListe.classList.add('gemessen');
    for (i = 0; i < lis.length; i++){
      lis[i].classList.remove('breit', 'umbruch');
    }
    for (i = 0; i < lis.length; i++){
      li = lis[i];
      // Passt der Text nicht in eine Spalte, bekommt die Pille beide.
      if (li.scrollWidth > li.clientWidth + 1) li.classList.add('breit');
    }
    for (i = 0; i < lis.length; i++){
      li = lis[i];
      // Reicht auch die volle Breite nicht, darf sie doch umbrechen.
      if (li.scrollWidth > li.clientWidth + 1) li.classList.add('umbruch');
    }
  }
  tagsMessen();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(tagsMessen);
  window.addEventListener('resize', tagsMessen);

  /* ---------- Verpackung: wachsende Zeile, dann Wortmarke, dann Schachtel --- */
  var packSec = document.getElementById('verpackung');
  var packH2 = packSec && packSec.querySelector('.copy h2');
  var packShot = packSec && packSec.querySelector('.pack-shot');
  var packImg = packShot && packShot.querySelector('img');
  /* Oberkante der Packung als Anteil der Bildhoehe. Aus mkpack.py:
     die Erkennung dort meldet sie als 0.1680 des vollen Bildes. */
  var PACK_OBEN = 0.1680;
  function packWachs(){
    if (!packH2) return;
    var r = packH2.getBoundingClientRect(), h = window.innerHeight;
    /* Der Weg betraegt gut drei Viertel Fensterhoehe - lang genug, dass man
       das Wachsen sieht, kurz genug, dass es nicht wie frueher ueber mehrere
       Bildschirme laeuft. */
    var p = (h - r.top) / (h * 0.78);
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    var e = 1 - Math.pow(1 - p, 3);
    packH2.style.setProperty('--wachs', (0.78 + 0.22 * e).toFixed(4));
    packSec.classList.toggle('marke-da', e > 0.5);
    /* Die Schachtel zaehlt ab dem Moment, in dem ihre Oberkante ins Bild
       kommt - sonst waere sie schon fertig eingeblendet, wenn man sie
       zum ersten Mal sieht. */
    if (packShot && packImg){
      var sr = packShot.getBoundingClientRect(), ir = packImg.getBoundingClientRect();
      /* Gemessen wird die Oberkante der Packung, nicht die des Bildes: das
         Bild bringt darueber leere Flaeche mit, und wie viel, haengt vom
         Ausschnitt ab. PACK_OBEN ist ihr Anteil an der Bildhoehe.
         Die Schwelle 0.82 ist am alten Aufbau nachgemessen: dort loeste die
         Einblendung aus, wenn die Oberkante der Packung diese Hoehe im
         Fenster erreichte. */
      var oben = sr.top + PACK_OBEN * ir.height;
      packSec.classList.toggle('schachtel-da', oben < h * 0.82);
    }
  }

  /* ---------- Kampagne: die 1000 folgt dem Scrollen ---------- */
  /* Gemessen wird am Fahrplan-Kasten, nicht an der 1000 selbst: solange die
     verschoben ist, liegt ihr Kasten woanders als ihr Platz, und jede Rechnung
     daran misst sich selbst. Der Fahrplan steht fest.
     Start bei 1,15 Fensterhoehen, Ende bei 0,80 - der Weg ist also gut ein
     Drittel Bildschirm lang. Weil der Wert bei jedem Bildaufbau neu aus der
     Lage kommt, laeuft er beim Hochscrollen von allein rueckwaerts. */
  var kasten = document.querySelector('.fahrplan');
  var tausend = document.querySelector('.tausend');
  function tausendAuf(){
    if (!kasten || !tausend) return;
    var h = window.innerHeight;
    var oben = kasten.getBoundingClientRect().top;
    var p = (h * 1.15 - oben) / (h * 0.35);
    p = p < 0 ? 0 : p > 1 ? 1 : p;
    /* Weich auslaufen, damit die letzten Pixel nicht abgehackt wirken. */
    tausend.style.setProperty('--auf', (1 - Math.pow(1 - p, 2)).toFixed(4));
  }

  /* Ohne Bewegung stehen Ueberschrift, Wortmarke, Schachtel und die 1000 von
     Anfang an auf dem Endzustand. Steht hier unten, weil die Elemente erst
     in diesem Teil des Skripts gesucht werden. */
  if (ruhig){
    if (packH2){
      packH2.style.setProperty('--wachs', '1');
      packSec.classList.add('marke-da', 'schachtel-da');
    }
    if (tausend) tausend.style.setProperty('--auf', '1');
  }

  function draw(){
    if (!ruhig){
      packWachs();
      tausendAuf();
    }
    barTone();
    var h = root.scrollHeight - window.innerHeight;
    if (bar) bar.style.width = (h > 0 ? (window.scrollY / h) * 100 : 0) + '%';
    navProgress();
    tick = false;
  }
  window.addEventListener('scroll', function(){ if (!tick){ tick = true; requestAnimationFrame(draw); } }, {passive:true});
  draw();
})();
